import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AuthService} from "../../services/AuthService";
import {CustomerUser} from "../../model/CustomerUser";
import {OperationsOverviewPage} from "../../pages/operatons-overview/operatons-overview";
import {QuotaPage} from "../../pages/quota/quota";
import {GalleryPage} from "../../pages/gallery/gallery";
import {HomePage} from "../../pages/home/home";
import {OrderListPage} from "../../pages/order-list/order-list";
import {MonthlyPlanningPage} from "../../pages/order-list/monthly-view";
import {StoreDirectoryPage} from "../../pages/store-directory/store-directory";
import {OperationCard} from "../../model/OperationCard";
import {QuotaBudgetPage} from "../../pages/quota/quota-budget";

/*
 * this provider is in charge of loading the menus we want to display
 */
@Injectable()
export class MenuItemsProvider {

  public pages: Array<{
    title: string, i18nKey: string, component: any, locupa2Route?: string, icon: any, badgeValue: any, moduleColor: string, showOnMenu: boolean,
    imageUrl?: string
  }>;

  constructor(public http: HttpClient,
              private authService: AuthService) {

  }

  /**
   * build pages for the logged user, will be built only once
   * @param loggedUser
   */
  buildPages(loggedUser: CustomerUser) {

    if (this.pages != null && this.pages.length > 0)
      return;

    if (loggedUser == null) {
      console.log("Will not build the menu, loggeduser is null");
      return;
    }


      this.buildMenuPage(loggedUser);

  }

  setPageBadgeValue(key: string, v: number): void {
    this.pages.forEach(p => {
      if (p.i18nKey == key)
        p.badgeValue = v;
    });
  }

  /**
   * ready to build, once all properties have been loaded
   * @param loggedUser
   * @param displayInvocing
   */
  private buildMenuPage(loggedUser: CustomerUser) {
    console.log("build pages for : " + loggedUser.email)
    if (this.pages == null) {
      this.pages = [];


      this.pages.push(
        {
          title: 'Accueil',
          i18nKey: 'menu.home',
          component: HomePage,
          icon: 'home',
          badgeValue: null,
          moduleColor: 'module-home',
          showOnMenu: false
        });

      this.pages.push(
        {
          title: 'Mes Opérations',
          i18nKey: 'menu.operations-overview',
          component: OperationsOverviewPage,
          icon: 'home',
          badgeValue: null,
          moduleColor: 'module-operations-overview',
          showOnMenu: true
        });

      this.pages.push(
        {
          title: 'Quota (Horaire)',
          i18nKey: 'menu.quota.hours',
          component: QuotaPage,
          icon: 'analytics',
          badgeValue: null,
          moduleColor: 'module-quota',
          showOnMenu: true
        });

      this.pages.push(
        {
          title: 'Quota',
          i18nKey: 'menu.quota.budget',
          component: QuotaBudgetPage,
          icon: 'analytics',
          badgeValue: null,
          moduleColor: 'module-quota-euro',
          showOnMenu: true
        });

      this.pages.push(
        {
          title: 'Planning Hebdo',
          i18nKey: 'menu.weekly-planning',
          component: OrderListPage,
          icon: 'calendar',
          badgeValue: null,
          moduleColor: 'module-planning-month',
          showOnMenu: true
        });

      this.pages.push(
        {
          title: 'Planning Mensuel',
          i18nKey: 'menu.weekly-planning',
          component: MonthlyPlanningPage,
          icon: 'calendar',
          badgeValue: null,
          moduleColor: 'module-planning',
          showOnMenu: true
        });

      this.pages.push(
        {
          title: 'Annuaire PdV',
          i18nKey: 'menu.store-directory',
          component: StoreDirectoryPage,
          icon: 'cart',
          badgeValue: null,
          moduleColor: 'module-store',
          showOnMenu: true
        });

      /**
      this.pages.push(
        {
          title: 'Galerie',
          i18nKey: 'menu.gallery',
          component: GalleryPage,
          icon: 'camera',
          badgeValue: null,
          moduleColor: 'module-gallery',
          showOnMenu: true
        });
    **/
      this.pages.push(
        {
          title: 'Galerie',
          i18nKey: 'menu.gallery',
          component: null,
          locupa2Route: 'photo-gallery',
          icon: 'camera',
          badgeValue: null,
          moduleColor: 'module-gallery',
          showOnMenu: true
        });

      if (loggedUser.pbiEmbedAllowed){
        this.pages.push(
          {
            title: 'Reporting',
            i18nKey: 'menu.powerBiEmbed',
            component: null,
            locupa2Route: 'power-bi-embed',
            icon: 'analytics',
            badgeValue: null,
            moduleColor: 'module-power-bi',
            showOnMenu: true
          });
      }
    }
  }

  /**
   * update menu items properties and visibility according to loaded cards
   * @param cards
   */
  updateFromOperationCards(cards: OperationCard[]) {
    if (this.pages != null) {
      let opeWithHourQuota = 0;
      let opeWithBudgetQuota = 0;

      if (cards != null) {
        for (let c of cards) {
          if (c.hourQuotaDefined)
            opeWithHourQuota++;
          if (c.budgetQuotaDefined)
            opeWithBudgetQuota++;
        }
      }

      for (let p of this.pages) {
        if (p.i18nKey == "menu.quota.budget") {
          p.showOnMenu = opeWithBudgetQuota > 0;
          p.badgeValue = opeWithBudgetQuota;
        } else if (p.i18nKey == "menu.quota.hours") {
          p.showOnMenu = opeWithHourQuota > 0;
          p.badgeValue = opeWithHourQuota;
        }
      }

    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/menu-items/menu-items.ts